<template>
  <div class='user-container'>
    <top></top>
    <div class="top-cell-wrapper">
      <van-cell title="收货地址" is-link value="" @click="toAddress" />
      <van-cell :title="'我的' +  userInfo.app.credit_alias" is-link :value="userInfo.credit + userInfo.app.credit_alias" @click="toCredit" />
      <van-cell title="兑换记录" is-link value="" @click="toExchange" />
    </div>
    <div class="bottom-cell-wrapper">
      <a href="tel:4000039990"><van-cell title="联系客服" is-link value="工作时间09:00~18:00" /></a>
      <van-cell title="软件版本" is-link value="V1.0.0" />
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import top from '@/components/top'
import bottom from '@/components/bottom'
import { Cell, CellGroup } from 'vant'

Vue.use(Cell).use(CellGroup)

export default {
  name: 'User',
  components: { top, bottom },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    toAddress() {
      this.$router.push({ path: '/user/address' })
    },

    toCredit() {
      this.$router.push({ path: '/user/credit/log' })
    },

    toExchange() {
      this.$router.push({ path: '/user/exchange/log' })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-container{
  .top-cell-wrapper{
    margin-top: 60px;
  }
  .bottom-cell-wrapper{
    margin-top: 10px;
  }
}
</style>
<style lang="scss">
.van-cell{
  width: 365px;
  height: 48px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue